<template>
    <li
    v-if="!item.hidden" 
        class="sidebar__item sidebar__item--sub">
        <template>
            <a
                class="sidebar__link"
                :class="{'disabled': item.disabled}"
                :href="item.href ? `${projectRootFolder}/#${item.href}` : '#'"> 
                <i 
                    v-if="item.icon" 
                    class="sidebar__icon"
                    :class="item.icon"/>
                <span class="sidebar__link__title">{{ item.title }}</span>
            </a>
        </template>
    </li>
</template>

<script>
import { animationMixin } from '../mixin'

export default {
    name: 'SubItem',
    mixins: [animationMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        projectRootFolder: {
            type: String
        }
    },
    methods: {
        clickEvent(event, href) {
            event.preventDefault();
            this.$emit('subItemClick', href);
            return false;
        }
    }
}
</script>
